





































































































































import { defineComponent } from "@vue/composition-api";
import { Button, Field, Form, Picker, Popup, Radio, RadioGroup, Search, Dialog, CellGroup, Cell, Steps, Step, PullRefresh, Checkbox, Icon } from "vant";
import _ from "lodash";
import moment from "moment";

moment.locale("zh-cn");

const STEPS = {
  SETTING: 0,
  AGREEMENT: 1,
  RECHARGE: 2,
  PAYMENT: 3,
  VALID: 4
};

export default defineComponent({
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Search.name]: Search,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [PullRefresh.name]: PullRefresh,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon
  },
  data: () => ({
    form: {
      id: 0,
      type: 1,
      bankAccountNo: "",
      bankAccountName: "",
      idNo: "",
      bankName: "",
      bankProvince: "",
      bankCity: "",
      bankDept: ""
    },
    hasUnpaidRecharge: false,
    validPayment: undefined,
    activeStep: STEPS.AGREEMENT,
    steps: STEPS,
    isAgreementAgreed: false,
    isEditEnable: false,
    isPullLoading: false,
    phoneCode: "",
    phoneCodeSendTime: 0,
    now: new Date(),
    resendTime: 59,
    nowUpdater: null,
    showBankNamePicker: false,
    bankNameList: [] as string[],
    bankNameSearch: "",
    showBankProvincePicker: false,
    bankProvinceList: [] as string[],
    bankProvinceSearch: "",
    showBankCityPicker: false,
    bankCityList: [] as string[],
    bankCitySearch: "",
    showBankDeptPicker: false,
    bankDeptList: [] as string[],
    bankDeptSearch: ""
  }),
  computed: {
    bankNameSearchList() {
      if (!this.bankNameSearch) return this.bankNameList;
      return this.bankNameList.filter(item => item.includes(this.bankNameSearch));
    },
    bankProvinceSearchList() {
      if (!this.bankProvinceSearch) return this.bankProvinceList;
      return this.bankProvinceList.filter(item => item.includes(this.bankProvinceSearch));
    },
    bankCitySearchList() {
      if (!this.bankCitySearch) return this.bankCityList;
      return this.bankCityList.filter(item => item.includes(this.bankCitySearch));
    },
    bankDeptSearchList() {
      if (!this.bankDeptSearch) return this.bankDeptList;
      return this.bankDeptList.filter(item => item.includes(this.bankDeptSearch));
    },
    secondsAfterPhoneCodeSendTime() {
      return Math.floor((this.now.getTime() - this.phoneCodeSendTime) / 1000);
    }
  },
  created() {
    this.fetchData();
    this.nowUpdater = setInterval(() => {
      this.now = new Date();
    }, 500);
  },
  beforeDestroy() {
    if (this.nowUpdater) {
      clearInterval(this.nowUpdater);
    }
  },
  methods: {
    async save() {
      if (!this.phoneCode) {
        this.$toast("请输入短信验证码");
        return;
      }
      if (!this.form.bankAccountNo) {
        this.$toast("请输入提现银行卡号");
        return;
      }
      if (!/^\d{1,25}$/.test(this.form.bankAccountNo)) {
        this.$toast("银行卡号格式不正确");
        return;
      }
      if (this.form.type === 1) {
        if (!this.form.bankAccountName || !this.form.idNo) {
          this.$toast("请输入提现人姓名和身份证号");
          return;
        }
        if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.form.idNo)) {
          this.$toast("身份证号格式不正确");
          return;
        }
      } else if (this.form.type === 2) {
        if (!this.form.bankAccountName || !this.form.bankName || !this.form.bankProvince || !this.form.bankCity || !this.form.bankDept) {
          this.$toast("请输入公司名称和开户行信息");
          return;
        }
      }
      await Dialog.confirm({ message: "确定要提交保存吗？" });
      this.$axios
        .post("/api/manage/settle/saveAccountSetting", {
          phoneCode: this.phoneCode,
          ...this.form
        })
        .then(() => {
          this.$toast.success("保存成功");
          this.cancelEdit();
        });
    },
    async sendPhoneCode() {
      await this.$axios.post("/api/manage/settle/sendSavePhoneCode");
      this.phoneCodeSendTime = new Date().getTime();
    },
    fetchData() {
      this.$axios
        .post("/api/manage/settle/accountSetting")
        .then(res => {
          const { setting, hasUnpaidRecharge, validPayment } = res.data.data;
          this.form = setting;
          this.hasUnpaidRecharge = hasUnpaidRecharge;
          this.validPayment = validPayment;
          if (setting.id === 0) {
            this.enableEdit();
          } else {
            if (setting.valid) {
              this.activeStep = this.steps.VALID;
            } else if (validPayment || (hasUnpaidRecharge && this.isAgreementAgreed)) {
              this.activeStep = this.steps.PAYMENT;
            } else {
              if (this.isAgreementAgreed) {
                this.activeStep = this.steps.RECHARGE;
              } else {
                this.activeStep = this.steps.AGREEMENT;
              }
            }
          }
        })
        .finally(() => {
          this.isPullLoading = false;
        });
    },
    enableEdit() {
      this.clearForm();
      this.isEditEnable = true;
    },
    async cancelEdit() {
      await this.fetchData();
      this.isEditEnable = false;
    },
    clearForm() {
      this.form.bankAccountNo = "";
      this.form.bankAccountName = "";
      this.form.idNo = "";
      this.form.bankName = "";
      this.form.bankProvince = "";
      this.form.bankCity = "";
      this.form.bankDept = "";
      this.phoneCode = "";
      this.isAgreementAgreed = false;
    },
    doAgree() {
      if (this.isAgreementAgreed) {
        this.isAgreementAgreed = false;
        return;
      }
      const element = this.$refs.agreeDiv;
      const isScrolledToEnd = element.scrollTop + element.clientHeight >= element.scrollHeight - 25; // 25 缓冲一下
      if (isScrolledToEnd) {
        this.isAgreementAgreed = true;
      } else {
        this.$toast("请先阅读并滑动到协议底部");
      }
    },
    async agreeNext() {
      if (!this.isAgreementAgreed) {
        this.$toast("请先同意协议");
        return;
      }
      await this.fetchData();
    },
    async doRecharge() {
      this.$toMiniApp(`/pages/settle-recharge/settle-recharge?amount=1&accountId=${this.form.accountId}`);
      await this.$dialog({
        message: "请在小程序中完成支付",
        showCancelButton: false,
        confirmButtonText: "确定"
      });
      const waitDuration = 3000;
      this.$toast.loading({
        message: "正在确认",
        forbidClick: true,
        duration: waitDuration
      });
      await new Promise(resolve => {
        setTimeout(() => {
          resolve(true);
        }, waitDuration);
      });
      await this.fetchData();
    },
    doPayment: _.throttle(
      async function() {
        await this.$dialog.confirm({ message: "确定发起验证吗?" });
        await this.$axios.post("/api/manage/settle/payValidAccountSetting");
        const waitDuration = 5000;
        this.$toast.loading({
          message: "正在确认",
          forbidClick: true,
          duration: waitDuration
        });
        await new Promise(resolve => {
          setTimeout(() => {
            resolve(true);
          }, waitDuration);
        });
        await this.fetchData();
      },
      500,
      {
        leading: true,
        trailing: false
      }
    ),
    doShowBankNamePicker() {
      this.fetchBankNameList().then(() => (this.showBankNamePicker = true));
    },
    async fetchBankNameList() {
      const res = await this.$axios.post("/api/manage/settle/bankNameList");
      this.bankNameList = res.data.data;
    },
    confirmBankName(name: string) {
      this.form.bankName = name;
      this.showBankNamePicker = false;
      this.form.bankProvince = "";
      this.form.bankCity = "";
      this.form.bankDept = "";
    },
    doShowBankProvincePicker() {
      if (!this.form.bankName) {
        this.$toast("请先选择银行");
        return;
      }
      this.fetchBankProvinceList().then(() => (this.showBankProvincePicker = true));
    },
    async fetchBankProvinceList() {
      const res = await this.$axios.post(`/api/manage/settle/bankProvinceList?bankName=${this.form.bankName}`);
      this.bankProvinceList = res.data.data;
    },
    confirmBankProvince(name: string) {
      this.form.bankProvince = name;
      this.showBankProvincePicker = false;
      this.form.bankCity = "";
      this.form.bankDept = "";
    },
    doShowBankCityPicker() {
      if (!this.form.bankProvince) {
        this.$toast("请先选择省份");
        return;
      }
      this.fetchBankCityList().then(() => (this.showBankCityPicker = true));
    },
    async fetchBankCityList() {
      const res = await this.$axios.post(`/api/manage/settle/bankCityList?bankName=${this.form.bankName}&province=${this.form.bankProvince}`);
      this.bankCityList = res.data.data;
    },
    confirmBankCity(name: string) {
      this.form.bankCity = name;
      this.showBankCityPicker = false;
      this.form.bankDept = "";
    },
    doShowBankDeptPicker() {
      if (!this.form.bankCity) {
        this.$toast("请先选择城市");
        return;
      }
      this.fetchBankDeptList().then(() => (this.showBankDeptPicker = true));
    },
    async fetchBankDeptList() {
      const res = await this.$axios.post(`/api/manage/settle/bankDeptList?bankName=${this.form.bankName}&province=${this.form.bankProvince}&city=${this.form.bankCity}`);
      this.bankDeptList = res.data.data;
    },
    confirmBankDept(name: string) {
      this.form.bankDept = name;
      this.showBankDeptPicker = false;
    },
    today() {
      return moment().format("YYYY年MM月DD日");
    },
    timeFormat(date: string) {
      return moment(date).format("YYYY年MM月DD日HH点mm分");
    },
    agreement() {
      return `<h1 id="电动车充电网-软件平台服务协议"><strong>《“电动车充电网”
软件平台服务协议》</strong></h1>
<p>甲方（软件平台运营方）：杭州雷风新能源科技有限公司<br />
乙方（设备运营商 / 设备所有者/ 提现人）：${this.form.bankAccountName} ${this.form.type === 1 ? this.form.idNo : ""}</p>
<p>甲方开发并运营 “电动车充电网” 小程序（以下简称
“本平台”），为乙方提供充电设备管理、订单信息展示、充电款项代收代付及结算服务；双方经友好协商，就平台服务事项达成一致，明确权利义务，特签订本协议。</p>
<h2 id="一服务内容"><strong>一、服务内容</strong></h2>
<ol type="1">
<li><p><strong>基础服务</strong>：<br />
甲方为乙方提供充电设备信息展示、充电订单管理、用户充电费用代收代付及提现结算服务。乙方通过本平台设置充电设备参数、查看运营数据、申请充电款项提现。</p></li>
<li><p><strong>代收代付功能</strong>：<br />
本平台仅作为充电款项的代收代付通道，充电收入由充电用户支付至平台结算户，甲方根据乙方设置的提现信息（包括但不限于设备运营商、站点分润方、设备所有者的分配比例及银行账户信息），扣除平台服务费及交易通道费用后，将剩余款项划付至乙方指定账户。</p></li>
</ol>
<h2
id="二账户管理与提现规则"><strong>二、账户管理与提现规则</strong></h2>
<ol type="1">
<li><p><strong>账户信息提交</strong>：<br />
乙方需在本平台如实填写提现人信息（个人用户需提供姓名、身份证号、银行卡号；对公用户需提供单位名称、统一社会信用代码、银行对公账户）。乙方承诺所填信息真实、准确、完整，并承担因信息错误导致提现失败、资金丢失或延迟到账的全部责任，甲方不承担任何责任。</p></li>
<li><p><strong>信息变更义务</strong>：<br />
若乙方账户信息发生变更，需提前在平台完成信息更新。因未及时更新导致的一切后果，由乙方自行承担。</p></li>
<li><p><strong>提现申请</strong>：<br />
乙方需在平台设定的结算周期（T+1）自动发起提现申请，甲方平台系统在24小时内完成审核并划款至提现人银行卡。</p></li>
</ol>
<h2
id="三资金结算与费用条款"><strong>三、资金结算与费用条款</strong></h2>
<ol type="1">
<li><p><strong>款项分配</strong>：<br />
充电款项按照乙方在平台设置的分配比例（设备运营商、站点分润方、设备所有者）进行拆分。乙方需确保分配参数设置正确，因设置错误导致的资金纠纷或损失，由乙方自行承担，甲方不承担任何责任。</p></li>
<li><p><strong>平台费用</strong>：<br />
甲方收取以下费用：</p>
<ol type="1">
<li><p><strong>资金交易通道服务费</strong>：按每笔充电订单金额的1%
收取，于结算时自动扣除；</p></li>
<li><p>设备年服务费：每个设备终端每年收取20元服务费（不含SIM卡流量费），设备服务费由运营商确认续费清单后，由软件平台从运营商的充电订单结算资金中自动扣除。</p></li>
</ol></li>
<li><p><strong>税务处理</strong>：<br />
乙方作为充电收入的实际收益方，需自行承担相关税费（包括但不限于增值税、企业所得税、个人所得税），并按法律法规要求申报缴纳。甲方不负责代扣代缴，亦不承担由此产生的任何税务责任。</p></li>
</ol>
<h2 id="四双方权利与责任"><strong>四、双方权利与责任</strong></h2>
<h3 id="一乙方权利与责任"><strong>（一）乙方权利与责任</strong></h3>
<ol type="1">
<li><p>有权使用本平台提供的管理及结算服务，查看充电订单及资金流水；</p></li>
<li><p>确保充电设备所有权清晰，不存在抵押、查封等权利瑕疵，若因设备权属纠纷导致平台服务受阻，乙方需赔偿甲方因此遭受的损失；</p></li>
<li><p>严格按照本协议约定设置资金分配参数，不得将本平台用于非充电场景的资金结算（包括但不限于借贷、投资、非法交易等）。若乙方违规使用平台，由此产生的全部法律责任（包括但不限于行政处罚、民事赔偿）由乙方承担，甲方有权立即终止服务；</p></li>
<li><p>妥善保管平台账户及密码，因乙方泄露账户信息或操作不当导致的损失，由乙方自行承担。</p></li>
<li><p>乙方需遵守《支付结算管理办法》、《网络安全法》等法律法规，确保充电交易真实合法，不得利用平台从事洗钱、套现等违法活动。</p></li>
</ol>
<h3 id="二甲方权利与责任"><strong>（二）甲方权利与责任</strong></h3>
<ol type="1">
<li><p>有权根据运营需要调整平台功能、服务条款及费用标准，但需提前 7
个工作日通过平台公告或短信通知乙方；</p></li>
<li><p>按照本协议约定为乙方提供安全、稳定的技术支持，但不保证平台绝对不出现故障或延迟。因不可抗力、黑客攻击、第三方支付系统故障等非甲方原因导致的服务中断或数据错误，甲方不承担责任；</p></li>
<li><p>对乙方提供的账户信息严格保密，除法律法规规定或监管要求外，不向任何第三方披露。</p></li>
</ol>
<h2 id="五协议变更与终止"><strong>五、协议变更与终止</strong></h2>
<ol type="1">
<li><p><strong>协议变更</strong>：<br />
甲方可通过平台公告方式修改本协议条款。若乙方不同意变更内容，可随时终止使用本平台，但已发生的交易仍需按原协议履行。乙方继续使用平台的，视为同意变更后的条款。</p></li>
<li><p><strong>协议终止</strong>：<br />
双方可协商一致终止本协议；若乙方存在违约行为（包括但不限于拖欠费用、违规使用平台、提交虚假信息），甲方有权单方面终止服务，并保留追究乙方违约责任的权利。</p></li>
</ol>
<h2 id="六保密条款"><strong>六、保密条款</strong></h2>
<p>双方对在合作过程中知悉的对方商业秘密、用户信息、技术数据等严格保密，不得向任何第三方披露，除非法律法规另有规定。本条款在协议终止后继续有效。</p>
<h2 id="七争议解决"><strong>七、争议解决</strong></h2>
<p>因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向甲方所在地有管辖权的人民法院提起诉讼。</p>
<h2 id="八其他"><strong>八、其他</strong></h2>
<ol type="1">
<li><p>本协议自提现人提现验证完成之日起生效；</p></li>
<li><p>本协议未尽事宜，可通过补充协议约定，补充协议与本协议具有同等效力。</p></li>
</ol>
<p>甲方：杭州雷风新能源科技有限公司</p>
<p>乙方：${this.form.bankAccountName}  ${this.form.type === 1 ? this.form.idNo : ""}</p>
<p>签订日期：${this.today()}</p>`;
    }
  }
});
